export default "__VITE_ASSET__hE$UlFiN__"